import React, { useState, useEffect } from 'react'
import DashboardBlock from './dashboardwidgetsblock';
import { getAssigned } from '../../../common/apiService';



export default function AssigendMeForReview({ jsonData, setGlobalAssignedToMe, globalassignedtome, loading, updateddata }) {
    const [assignedcases, setAssignedCases] = useState(0);

    const getData = async () => {
        let dtype = jsonData.dateType || jsonData.DateType;
        delete jsonData['dateType'];
        jsonData.DateType = dtype;
        const plazaIds = Array.isArray(jsonData.plazaIds) ? jsonData.plazaIds.join(",") : jsonData.plazaIds; 
        jsonData.plazaIds = plazaIds;
        const { data } = await getAssigned(jsonData);
        setAssignedCases(data.cases);
        setGlobalAssignedToMe(data.cases);
        // setAssigntoMeData(data)
    }

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, [updateddata, jsonData]);

    useEffect(() => {
        setAssignedCases(globalassignedtome);
        // eslint-disable-next-line
    }, [globalassignedtome])

    return (
        <DashboardBlock
            classname="violence-block"
            title="Assigned me for review"
            count={assignedcases}
            showbutton={true}
            link="/dashboard/assignedtomelisting"
            btnname="View assigned"
            total={66037} 
            showamount={false}
            showpercent={false}
            loader={loading} />
    )
}
